export const permissionsByOrder = [
  'full',
  'view',
  'block'
];
